var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 74,
    viewBox: "0 0 135 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2544_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 51.4553H13.3876C26.2363 51.4553 29.0344 43.6538 29.0344 36.8055C29.0344 29.6071 25.5796 22.506 13.3876 22.506H-1V51.4553ZM8.62233 30.8716H11.9313C18.4413 30.8716 19.041 34.8016 19.041 36.8639C19.041 38.9262 18.4699 43.0895 11.9313 43.0895H8.62233V30.8716Z",
    fill: "#1F774D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1704 30.0156H47.3431C48.942 30.0156 49.5131 30.9301 49.5131 32.1363C49.5131 33.3425 48.942 34.2569 47.3431 34.2569H41.1704V30.0156ZM41.1704 41.8833H45.6299C48.7423 41.8833 49.8273 43.7122 49.8273 46.825V51.4553C49.8273 51.4553 58.1223 51.4553 59.5066 51.4553V43.9456C59.5066 40.2102 57.7935 37.681 54.7954 36.8639C56.5657 36.2413 59.4209 34.4125 59.4209 30.0545C59.4209 24.7628 56.1374 22.506 50.798 22.506H31.548V51.4553H41.1704V41.8833Z",
    fill: "#1F774D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2873 22.506H62.6935V51.4553H72.2873V22.506Z",
    fill: "#1F774D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5423 43.0506C101.509 43.0506 103.821 37.9923 103.821 32.6615C103.821 27.253 101.566 22.506 93.5423 22.506H75.5808V51.4553H85.203V43.0506H93.5423ZM85.203 30.4436H91.6289C93.3145 30.4436 93.8845 31.4164 93.8845 32.7005C93.8845 33.9456 93.3145 34.9573 91.6289 34.9573H85.203V30.4436Z",
    fill: "#1F774D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.886 52C131.536 52 135.404 46.786 135.404 41.7666C135.404 35.8521 132.378 32.9728 124.182 32.6614L120.128 32.5448C116.53 32.428 115.788 31.6887 115.788 30.5603V30.5214C115.788 29.4708 116.317 28.6926 119.629 28.6926C123.227 28.6926 123.698 30.3269 123.783 31.3774H134.633V31.105C134.633 26.3191 130.521 22 119.5 22C109.421 22 105.023 25.8716 105.023 30.9689C105.023 35.5214 106.994 39.821 115.531 40.1323L119.757 40.2879C123.783 40.4824 124.182 41.4163 124.182 42.6226V42.7003C124.182 43.9067 123.44 45.035 120.014 45.035C116.273 45.035 115.788 42.856 115.702 41.4941H104.681V41.8443C104.681 45.5798 107.522 52 119.886 52Z",
    fill: "#1F774D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2544_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 74,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrips);
export default __webpack_public_path__ + "static/media/drips.9dc00f9640a45697c7a607ab9314f1a4.svg";
export { ForwardRef as ReactComponent };